import React, { useContext, useEffect, useState } from "react";
import { ScoreContext } from "./ScoreContext"; // Import ScoreContext
import {  Row, Col, Button, Table,Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";


const ActionPlan = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    return JSON.parse(localStorage.getItem("isSidebarCollapsed")) || false;
  });

  useEffect(() => {
    // Save the updated state to localStorage
    localStorage.setItem("isSidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

       const handleSidebarToggle = () => {
    // Toggle the sidebar state
    setIsSidebarCollapsed((prevState) => !prevState);
  };

  const navigate = useNavigate();
  const { actionPlan, fetchActionPlan ,loading } = useContext(ScoreContext); // Add default fallback to an empty array
  
  useEffect(() => {
    const fetchData = async () => {
      if (!loading) {
        await fetchActionPlan(); // Call fetchActionPlan once
      }
    };
    fetchData();
  }, []);

  
  return (
    <>
      <Row  className="  g-0">
      
        <Col
          xs={12}
          md={isSidebarCollapsed ? 11 : 10}
          className="p-4 "
        >
        
          <p style={{ paddingBottom: "20px" }}>
          Areas requiring further action with recommendations. For additional support, contact a ServQual Security subject matter expert.
            
          </p>
          {loading ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </Spinner>
            </div>
          ) : actionPlan.length === 0 ? (
            <p>No items in the Action Plan.</p>
          ) : (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Areas that need further action</th>
                  <th>Recommendation</th>
                </tr>
              </thead>
              <tbody>
                {actionPlan.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <strong>●</strong> {item.question || "No question available"}
                    </td>
                    <td>
                      {item.moreInformation ? (
                        <a href={item.moreInformation.link} target="_blank" rel="noopener noreferrer">
                          {item.moreInformation.text || "More Information"}
                        </a>
                      ) : (
                        "No recommendation available"
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
         
         
        </Col>
      </Row>

     

     
    </>
  );
};

export default ActionPlan;
